import styled from 'styled-components';
import { Box } from '@mui/material';

export const FieldsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 300px;
`;
